import { useAuth } from './hooks/useAuth';
import { Login } from './components/Login';
import { HannahApp } from './components/HannahApp';

export default function App() {
  const { isAuthenticated, isLoading, login, logout, getToken } = useAuth();

  if (isLoading) {
    return (
      <div className="loading">
        <img src="/hannah-avatar.png" alt="Hannah" className="loading-logo" />
        <p>Connecting to Hannah...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLogin={login} />;
  }

  const token = getToken();
  if (!token) {
    return <Login onLogin={login} />;
  }

  return <HannahApp token={token} onLogout={logout} />;
}
